// tslint:disable:max-line-length
import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeBase } from '../../components/e5core-ui-work-field/e5core-ui-work-field-type-base';
import {  UIPropertyModel, ListItemModel, ListSearchService } from 'e5core-angular-services';
import { WorkFieldListChangeEvent } from '../../events/work-field-list-change-event';
import { UiStyleService } from '../../services/ui-style.service';
import { CachedListSearchService } from '../../services/cached-list-search.service';

/*
 *
 *	When a list is in "Find" view, it can have the following values.
 *	"" - [0]
 *	"(any value)" - [-1]
 *	"(no value)" - [-2]
 *	"VALUE" - [>0]
 */
@Component({
	selector: 'e5core-ui-work-field-type-list',
	template: `
	<span [ngSwitch]="style.current()">
		<e5core-ui-work-field-type-list-box *ngSwitchCase='0' [workItem$]='workItem$' [list]='list' [selected]='selected' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-list-box>
		<e5core-ui-work-field-type-list-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [list]='list' [selected]='selected' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-list-bootstrap>
		<e5core-ui-work-field-type-list-material *ngSwitchCase='2' [workItem$]='workItem$' [list]='list' [selected]='selected' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-list-material>
	</span>`
})
export class E5coreUiWorkFieldTypeListComponent extends E5coreUiWorkFieldTypeBase {

	list: ListItemModel[];
	selected: string ;

	constructor(public style:UiStyleService, private listService: CachedListSearchService) {
		super();
	}

	valueChange($event: WorkFieldListChangeEvent) {
		this.dispatchPropertyChange(this.property.propertyId, $event.id.toString(), $event.error);
	}

	ngOnInit() {
		super.ngOnInit();

		this.workItem$.subscribe(
			wim => {
				if (this.property && (this.property.listId || this.property.propertyId)) {
					// If the listId is 0 then we can quiry the list using the propertyId. This is to
					// handle the situation for System Lists list Status_Id, Category1_Id, etc that
					// do not have a coresponding ListId.
					let listId = this.property.listId || this.property.propertyId;
					// If the list has a parentListId or a parentPropertyId then we need to find the
					// selected value of that property, so that we know how to filter this property.
					let parentProperty: UIPropertyModel;
					if (this.property.parentListId) {
						parentProperty = wim.properties.find(p => p.listId == this.property.parentListId);
					}
					if (!parentProperty && this.property.parentPropertyId) {
						parentProperty = wim.properties.find(p => p.propertyId == this.property.parentPropertyId);
					}
					let property = wim.properties.find(p => p.propertyId == this.property.propertyId); // Latest version
					this.loadList(listId, parentProperty, property);
				}
			}
		)
	}

	private loadList(listId: any, parent: UIPropertyModel, property:UIPropertyModel) {
		let options: any;
		if (parent) {
			// The parent property is on the page, however, if it's empty then this list should also be empty
			if (!parent.value || parent.value == "0") {
				this.clearList() ;
				return;
			}
			options = { parentListItemId: parent.value };
		}

		this.listService.search(listId, options).subscribe(
			list => {
				this.list = list || [] ;
				if(list.length > 0 && this.field.inFindMode) {					
					let currentSelected = property.value ;
					let inList = this.list.find(i => i.id == currentSelected) != undefined ;
					this.selected = (currentSelected == "0" || !inList) ? undefined : currentSelected ;
				} else {
					this.clearList();
				}
			},
			error => this.clearList()
		)
	}

	private clearList() {
		this.list = [] ;
		this.selected = undefined ;
	}
}
